module.exports = __webpack_public_path__ + "img/9788937833618.788df213.jpg";